// src/data/useRole.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth } from "./auth";
import { db } from "./firebase";

// Roles: "viewer" | "editor"
// Strict mode: requires users/{uid} doc with { active: true, role: "viewer"|"editor" }
export function useRole() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);     // null until loaded
  const [active, setActive] = useState(false); // strict: default false
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (!u) {
        setRole(null);
        setActive(false);
        setLoading(false);
        return;
      }
      try {
        const snap = await getDoc(doc(db, "users", u.uid));
        if (!snap.exists()) {
          // No allowlist doc -> inactive
          setRole(null);
          setActive(false);
        } else {
          const data = snap.data() || {};
          setRole(typeof data.role === "string" ? data.role : null);
          setActive(Boolean(data.active));
        }
      } catch {
        // On error, treat as inactive to be safe
        setRole(null);
        setActive(false);
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  const canEdit = active && role === "editor";
  return { user, role, active, canEdit, loading };
}
